<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="筛选学校">
                        <el-select v-model="semester_type_id"
                                   placeholder="请选择学期"
                                   multiple
                                   clearable
                                   @change="handleIndexDiscountType()">
                            <el-option
                                    v-for="item in semester_types"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right m-b-0">
            <div class="m-portlet__body" :style="{'height':(clientHeight-150)+'px'}" v-loading="loading">
                    <el-table v-if="!loading"
                              :data="discountTypes"
                              style="width: 100%"
                              :height="clientHeight-180"
                              size="middle">
                        <el-table-column prop="name" label="类型" min-width="26px"></el-table-column>
                        <el-table-column label="开始日期" min-width="18px">
                            <template slot-scope="scope">
                                <el-date-picker
                                        v-model="scope.row.start_date"
                                        size="small"
                                        type="date"
                                        :clearable="false"
                                        value-format="yyyy-MM-dd"
                                        style="width: 80%"
                                        placeholder="日期">
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column label="结束日期" min-width="18px">
                            <template slot-scope="scope">
                                <el-date-picker
                                        v-model="scope.row.end_date"
                                        size="small"
                                        type="date"
                                        :clearable="false"
                                        value-format="yyyy-MM-dd"
                                        style="width: 80%"
                                        placeholder="日期">
                                </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column label="叠加" min-width="14px">
                            <template slot-scope="scope">
                                <el-radio-group v-model="scope.row.overlay">
                                    <el-radio :label="0">是</el-radio>
                                    <el-radio :label="1">否</el-radio>
                                </el-radio-group>
                            </template>
                        </el-table-column>
                        <el-table-column label="重复使用" min-width="14px">
                            <template slot-scope="scope">
                                <el-radio-group v-model="scope.row.chooseType">
                                    <el-radio :label="0">是</el-radio>
                                    <el-radio :label="1">否</el-radio>
                                </el-radio-group>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="10px">
                            <template slot-scope="scope">
                                <el-button type="primary" size="small" @click="handleUpdateDiscountType(scope.row)" :loading="button_loading">保存</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                path: '/discountTypes',
                loading: true,
                button_loading: false,
                discountTypes: [],
                semester_type_id:[],
                semester_types:[],
                currentPage: 1,
                currentPageSize: 10,
                total: 0,
            }
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            clientWeight() {
                return this.$store.state.config.clientWidth;
            },
        },
        created() {
            this.handleCreate();
            this.handleInit();
            this.handleIndexDiscountType();
        },

        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleInit(){
                this.$wApi.send(this.path, 'init');
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.semester_types = data.semester_types;
                        break;
                    case 'get_discountTypes':
                        this.discountTypes = data.discountTypes;
                        this.total=data.total;
                        this.loading = false;
                        break;
                    case 'update_discountType':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.button_loading = false;
                        break;
                    case 'update_discountType_error':
                        this.button_loading = false;
                        break;
                }
            },
            //获取优惠模板
            handleIndexDiscountType(currentPage=1) {
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'get_discountTypes',{
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'semester_type_ids': this.semester_type_id,
                });
            },
            handleUpdateDiscountType(discountType) {
                this.button_loading = true;
                this.$wApi.send(this.path, 'update_discountType', {
                    'id': discountType.id,
                    'overlay': discountType.overlay,
                    'chooseType': discountType.chooseType,
                    'start_date': discountType.start_date,
                    'end_date': discountType.end_date,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexDiscountType(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexDiscountType(this.currentPage)
            },
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
